export function slugToLink(slug?: string | null) {
    if (!slug) {
        return '#'
    }

    if (slug.startsWith('/') || slug.startsWith('http')) {
        return slug
    }

    return '/' + slug
}
